// Phase 6B · Communications — outbound email API helpers.
// Additive. No modification to any locked lib.
import axios from "axios";
import { API } from "@/contexts/AuthContext";

const BASE = `${API}/comm/outbound`;

export async function listTemplates() {
  const { data } = await axios.get(`${BASE}/templates`);
  return data?.items || [];
}

export async function createTemplate({ name, subject, body_html }) {
  const { data } = await axios.post(`${BASE}/templates`, {
    name, subject, body_html,
  });
  return data;
}

export async function updateTemplate(id, { name, subject, body_html }) {
  const { data } = await axios.put(`${BASE}/templates/${id}`, {
    name, subject, body_html,
  });
  return data;
}

export async function deleteTemplate(id) {
  await axios.delete(`${BASE}/templates/${id}`);
}

export async function proposeOutbound({
  recipients, subject, body_html, template_id = null,
  source_entity_type, source_entity_id = null, attachment_refs = [],
}) {
  const { data } = await axios.post(`${BASE}/propose`, {
    recipients, subject, body_html, template_id,
    source_entity_type, source_entity_id, attachment_refs,
  });
  return data;
}

export async function confirmOutbound(pending_id, confirmation_token) {
  const { data } = await axios.post(`${BASE}/confirm`, {
    pending_id, confirmation_token,
  });
  return data;
}

export async function listEmailLog() {
  const { data } = await axios.get(`${BASE}/log`);
  return data?.items || [];
}
